function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PeersTemplate = require('./peers.template');
var AdminPeersUI = /*#__PURE__*/function () {
  function AdminPeersUI(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-peers';
    _classCallCheck(this, AdminPeersUI);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.configured = [];
    this.live = [];
    this.error = '';
    this.notice = '';
    this.loading_live = false;
    this.show_add_form = false;
    this.saving_server = false;
    this.detail = null;
  }
  return _createClass(AdminPeersUI, [{
    key: "render",
    value: function render() {
      var _this$mod$server_info;
      this.error = '';
      this.notice = '';
      this.live = [];
      this.show_add_form = false;
      this.detail = null;
      if (!this.mod.server_info) {
        this.app.browser.replaceElementContentBySelector("<p class=\"admin-peers-empty\">Waiting for the server to finish authenticating this administrator.</p>", this.container);
        return;
      }
      this.configured = this.copyPeers(((_this$mod$server_info = this.mod.server_info) === null || _this$mod$server_info === void 0 || (_this$mod$server_info = _this$mod$server_info.options) === null || _this$mod$server_info === void 0 ? void 0 : _this$mod$server_info.peers) || []);
      this.refresh();
      this.loadLivePeers();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this$mod$server_info2, _this$mod$server_info3;
      this.app.browser.replaceElementContentBySelector(PeersTemplate(_objectSpread(_objectSpread({}, this.serverAddress()), {}, {
        local_host: (_this$mod$server_info2 = this.mod.server_info) === null || _this$mod$server_info2 === void 0 || (_this$mod$server_info2 = _this$mod$server_info2.options) === null || _this$mod$server_info2 === void 0 || (_this$mod$server_info2 = _this$mod$server_info2.server) === null || _this$mod$server_info2 === void 0 ? void 0 : _this$mod$server_info2.host,
        local_port: (_this$mod$server_info3 = this.mod.server_info) === null || _this$mod$server_info3 === void 0 || (_this$mod$server_info3 = _this$mod$server_info3.options) === null || _this$mod$server_info3 === void 0 || (_this$mod$server_info3 = _this$mod$server_info3.server) === null || _this$mod$server_info3 === void 0 ? void 0 : _this$mod$server_info3.port,
        peers: this.peerRows(),
        error: this.error,
        notice: this.notice,
        loading_live: this.loading_live,
        show_add_form: this.show_add_form,
        detail: this.detail
      })), this.container);
      this.attachEvents();
    }
  }, {
    key: "copyPeers",
    value: function copyPeers(peers) {
      return (peers || []).map(function (p) {
        return {
          host: p.host || '',
          port: p.port,
          protocol: p.protocol || 'https',
          synctype: p.synctype || 'full'
        };
      });
    }
  }, {
    key: "serverAddress",
    value: function serverAddress() {
      var _this$mod$server_info4;
      var server = ((_this$mod$server_info4 = this.mod.server_info) === null || _this$mod$server_info4 === void 0 || (_this$mod$server_info4 = _this$mod$server_info4.options) === null || _this$mod$server_info4 === void 0 ? void 0 : _this$mod$server_info4.server) || {};
      var endpoint = server.endpoint || server;
      var protocol = endpoint.protocol || server.protocol || 'http';
      var host = endpoint.host || server.host || '';
      var port = endpoint.port || server.port || '';
      return {
        protocol: protocol === 'https' ? 'https' : 'http',
        host: String(host || ''),
        port: port === '' || port == null ? '' : String(port)
      };
    }
  }, {
    key: "peerKey",
    value: function peerKey(peer) {
      var host = String(peer.host || '').toLowerCase();
      if (host) {
        return "".concat(host, "|").concat(String(peer.port || ''));
      }
      return "pk|".concat(peer.publicKey || '');
    }
  }, {
    key: "peerRows",
    value: function peerRows() {
      var liveByKey = new Map();
      var _iterator = _createForOfIteratorHelper(this.live),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var peer = _step.value;
          liveByKey.set(this.peerKey(peer), peer);
          if (peer.publicKey) {
            liveByKey.set("pk|".concat(peer.publicKey), peer);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var rows = [];
      var seen = new Set();
      var _iterator2 = _createForOfIteratorHelper(this.configured),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _peer = _step2.value;
          var key = this.peerKey(_peer);
          seen.add(key);
          var live = liveByKey.get(key);
          rows.push({
            key: key,
            host: _peer.host || '',
            port: _peer.port || '',
            publicKey: (live === null || live === void 0 ? void 0 : live.publicKey) || '',
            verified: !!(live !== null && live !== void 0 && live.publicKey),
            saved: true,
            detail: _objectSpread(_objectSpread({}, live || {}), {}, {
              host: _peer.host || (live === null || live === void 0 ? void 0 : live.host) || '',
              port: _peer.port || (live === null || live === void 0 ? void 0 : live.port) || '',
              protocol: _peer.protocol || (live === null || live === void 0 ? void 0 : live.protocol) || '',
              synctype: _peer.synctype || (live === null || live === void 0 ? void 0 : live.synctype) || '',
              publicKey: (live === null || live === void 0 ? void 0 : live.publicKey) || '',
              status: (live === null || live === void 0 ? void 0 : live.status) || '',
              saved: true
            })
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(this.live),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _peer2 = _step3.value;
          var _key = this.peerKey(_peer2);
          if (!_peer2.host && !_peer2.publicKey) {
            continue;
          }
          if (_peer2.host && seen.has(_key)) {
            continue;
          }
          if (seen.has(_key)) {
            continue;
          }
          seen.add(_key);
          rows.push({
            key: _key,
            host: _peer2.host || '',
            port: _peer2.port || '',
            publicKey: _peer2.publicKey || '',
            verified: !!_peer2.publicKey,
            saved: false,
            detail: _objectSpread(_objectSpread({}, _peer2), {}, {
              saved: false
            })
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return rows;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var refreshBtn = document.getElementById('admin-peers-refresh');
      if (refreshBtn) {
        refreshBtn.onclick = function () {
          return _this.loadLivePeers();
        };
      }
      var updateBtn = document.getElementById('admin-server-update');
      if (updateBtn) {
        updateBtn.onclick = function () {
          return _this.updateServerAddress();
        };
      }
      var toggleAdd = document.getElementById('admin-peer-add-toggle');
      if (toggleAdd) {
        toggleAdd.onclick = function () {
          _this.show_add_form = !_this.show_add_form;
          _this.refresh();
        };
      }
      var addBtn = document.getElementById('admin-peer-add');
      if (addBtn) {
        addBtn.onclick = function () {
          return _this.addPeer();
        };
      }
      var hostInput = document.getElementById('admin-peer-host');
      if (hostInput) {
        hostInput.onkeydown = function (e) {
          if (e.key === 'Enter') {
            _this.addPeer();
          }
        };
      }
      document.querySelectorAll('[data-peer-type]').forEach(function (select) {
        select.onclick = function (e) {
          return e.stopPropagation();
        };
        select.onchange = function (e) {
          e.stopPropagation();
          _this.setPeerSaved(select.getAttribute('data-peer-key'), select.value === 'saved');
        };
      });
      document.querySelectorAll('.admin-peer-row').forEach(function (row) {
        row.onclick = function () {
          return _this.showPeerDetail(row.getAttribute('data-peer-key'));
        };
        row.onkeydown = function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this.showPeerDetail(row.getAttribute('data-peer-key'));
          }
        };
      });
      var closeDetail = function closeDetail() {
        _this.detail = null;
        _this.refresh();
      };
      var backdrop = document.getElementById('admin-peer-detail-close');
      if (backdrop) {
        backdrop.onclick = function (e) {
          if (e.target === backdrop) {
            closeDetail();
          }
        };
      }
      var dismiss = document.getElementById('admin-peer-detail-dismiss');
      if (dismiss) {
        dismiss.onclick = closeDetail;
      }
    }
  }, {
    key: "showPeerDetail",
    value: function showPeerDetail(key) {
      var row = this.peerRows().find(function (peer) {
        return peer.key === key;
      });
      if (!(row !== null && row !== void 0 && row.detail)) {
        return;
      }
      this.detail = row.detail;
      this.refresh();
    }
  }, {
    key: "updateServerAddress",
    value: function () {
      var _updateServerAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _document$getElementB,
          _document$getElementB2,
          _document$getElementB3,
          _this$mod$server_info5,
          _this2 = this;
        var protocol, host, port, current, server, tx, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.saving_server) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              protocol = (((_document$getElementB = document.getElementById('admin-server-protocol')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value) || '').trim();
              host = (((_document$getElementB2 = document.getElementById('admin-server-host')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value) || '').trim();
              port = (((_document$getElementB3 = document.getElementById('admin-server-port')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.value) || '').trim();
              if (!(!host || !port || protocol !== 'http' && protocol !== 'https')) {
                _context.n = 2;
                break;
              }
              this.error = 'A protocol, host, and port are needed to update the server address.';
              this.notice = '';
              this.refresh();
              return _context.a(2);
            case 2:
              this.saving_server = true;
              this.error = '';
              this.notice = '';
              current = ((_this$mod$server_info5 = this.mod.server_info) === null || _this$mod$server_info5 === void 0 || (_this$mod$server_info5 = _this$mod$server_info5.options) === null || _this$mod$server_info5 === void 0 ? void 0 : _this$mod$server_info5.server) || {};
              server = _objectSpread(_objectSpread({}, current), {}, {
                endpoint: _objectSpread(_objectSpread({}, current.endpoint || {}), {}, {
                  host: host,
                  port: Number(port) || port,
                  protocol: protocol
                })
              });
              _context.p = 3;
              _context.n = 4;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 4:
              tx = _context.v;
              tx.msg = {
                module: 'Admin',
                request: 'update-options',
                data: {
                  server: server
                }
              };
              _context.n = 5;
              return tx.sign();
            case 5:
              _context.n = 6;
              return this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                var _this2$mod$server_inf;
                var res = typeof res_tx.returnMessage === 'function' ? res_tx.returnMessage() : res_tx;
                if (res !== null && res !== void 0 && res.err) {
                  _this2.error = res.err;
                  _this2.notice = '';
                  _this2.refresh();
                  return;
                }
                if ((_this2$mod$server_inf = _this2.mod.server_info) !== null && _this2$mod$server_inf !== void 0 && _this2$mod$server_inf.options) {
                  _this2.mod.server_info.options.server = _objectSpread(_objectSpread({}, _this2.mod.server_info.options.server || {}), server);
                }
                _this2.notice = 'Server address saved.';
                _this2.error = '';
                _this2.refresh();
                if (typeof siteMessage === 'function') {
                  siteMessage('Server address saved');
                }
              }, this.mod.server_publickey);
            case 6:
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              this.error = _t.message || String(_t);
              this.notice = '';
              this.refresh();
            case 8:
              _context.p = 8;
              this.saving_server = false;
              return _context.f(8);
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[3, 7, 8, 9]]);
      }));
      function updateServerAddress() {
        return _updateServerAddress.apply(this, arguments);
      }
      return updateServerAddress;
    }()
  }, {
    key: "setPeerSaved",
    value: function setPeerSaved(key, saved) {
      var _this3 = this;
      var index = this.configured.findIndex(function (peer) {
        return _this3.peerKey(peer) === key;
      });
      if (saved && index >= 0) {
        return;
      }
      if (!saved) {
        this.removePeer(index);
        return;
      }
      var live = this.live.find(function (peer) {
        return _this3.peerKey(peer) === key;
      });
      if (!(live !== null && live !== void 0 && live.host) || !(live !== null && live !== void 0 && live.port)) {
        this.error = 'That peer does not have a host and port to save.';
        this.notice = '';
        this.refresh();
        return;
      }
      var protocol = live.protocol === 'http' ? 'http' : 'https';
      this.configured.push({
        host: live.host,
        port: Number(live.port),
        protocol: protocol,
        synctype: live.synctype === 'lite' ? 'lite' : 'full'
      });
      this.savePeers('add');
    }
  }, {
    key: "addPeer",
    value: function addPeer() {
      var _this4 = this;
      var hostInput = document.getElementById('admin-peer-host');
      var portInput = document.getElementById('admin-peer-port');
      var protocolInput = document.getElementById('admin-peer-protocol');
      var host = ((hostInput === null || hostInput === void 0 ? void 0 : hostInput.value) || '').trim();
      var port = ((portInput === null || portInput === void 0 ? void 0 : portInput.value) || '').trim();
      var protocol = ((protocolInput === null || protocolInput === void 0 ? void 0 : protocolInput.value) || 'https').trim();
      if (host.includes('://')) {
        try {
          var url = new URL(host);
          protocol = url.protocol.replace(':', '') || protocol;
          host = url.hostname;
          if (url.port) {
            port = url.port;
          }
        } catch (err) {
          this.error = 'That does not look like a valid peer address.';
          this.notice = '';
          this.refresh();
          return;
        }
      }
      if (protocol === 'http' && !port) {
        port = '12101';
      }
      if (protocol === 'https' && !port) {
        port = '443';
      }
      if (!host || !port || protocol !== 'http' && protocol !== 'https') {
        this.error = 'A host, port, and protocol are needed to add a permanent peer.';
        this.notice = '';
        this.refresh();
        return;
      }
      var peer = {
        host: host,
        port: Number(port),
        protocol: protocol,
        synctype: 'full'
      };
      if (this.configured.some(function (p) {
        return _this4.peerKey(p) === _this4.peerKey(peer);
      })) {
        this.error = 'That peer is already in the permanent list.';
        this.notice = '';
        this.refresh();
        return;
      }
      this.configured.push(peer);
      this.show_add_form = false;
      this.savePeers('add');
    }
  }, {
    key: "removePeer",
    value: function removePeer(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.configured.length) {
        return;
      }
      this.configured.splice(index, 1);
      this.savePeers('remove');
    }
  }, {
    key: "responseMessage",
    value: function responseMessage(res_tx) {
      return typeof (res_tx === null || res_tx === void 0 ? void 0 : res_tx.returnMessage) === 'function' ? res_tx.returnMessage() : res_tx;
    }
  }, {
    key: "savePeers",
    value: function () {
      var _savePeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(action) {
        var _this5 = this;
        var tx;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.error = '';
              this.notice = '';
              this.refresh();
              _context2.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context2.v;
              tx.msg = {
                module: 'Admin',
                request: 'update-peers',
                peers: this.configured
              };
              _context2.n = 2;
              return tx.sign();
            case 2:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                var _this5$mod$server_inf2;
                var res = _this5.responseMessage(res_tx);
                if (res !== null && res !== void 0 && res.err) {
                  var _this5$mod$server_inf;
                  _this5.configured = _this5.copyPeers(((_this5$mod$server_inf = _this5.mod.server_info) === null || _this5$mod$server_inf === void 0 || (_this5$mod$server_inf = _this5$mod$server_inf.options) === null || _this5$mod$server_inf === void 0 ? void 0 : _this5$mod$server_inf.peers) || []);
                  _this5.error = res.err;
                  _this5.notice = '';
                  _this5.refresh();
                  return;
                }
                if ((_this5$mod$server_inf2 = _this5.mod.server_info) !== null && _this5$mod$server_inf2 !== void 0 && _this5$mod$server_inf2.options) {
                  _this5.mod.server_info.options.peers = _this5.copyPeers(_this5.configured);
                }
                if (action === 'add' && res !== null && res !== void 0 && res.connecting) {
                  _this5.notice = 'This peer is now in the server configuration, and Saito is attempting to connect to it. If it does not appear above, use Refresh. The connection is kept across restarts.';
                } else if (action === 'add') {
                  _this5.notice = 'This peer is now in the server configuration. Saito will attempt to connect to it the next time the server starts.';
                } else {
                  _this5.notice = 'This peer has been removed from the server configuration. If it is still connected, that connection will remain until it drops or Saito restarts.';
                }
                _this5.refresh();
                _this5.loadLivePeers();
                if (typeof siteMessage === 'function') {
                  siteMessage('Peer configuration saved');
                }
              }, this.mod.server_publickey);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function savePeers(_x) {
        return _savePeers.apply(this, arguments);
      }
      return savePeers;
    }()
  }, {
    key: "loadLivePeers",
    value: function () {
      var _loadLivePeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this6 = this;
        var tx;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.loading_live = true;
              this.refresh();
              _context3.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.mod.server_publickey);
            case 1:
              tx = _context3.v;
              tx.msg = {
                module: 'Admin',
                request: 'list-peers'
              };
              _context3.n = 2;
              return tx.sign();
            case 2:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                _this6.loading_live = false;
                var res = _this6.responseMessage(res_tx);
                if (res !== null && res !== void 0 && res.err) {
                  _this6.error = res.err;
                  _this6.live = [];
                  _this6.refresh();
                  return;
                }
                _this6.live = ((res === null || res === void 0 ? void 0 : res.result) || []).map(function (p) {
                  return {
                    publicKey: p.publicKey || '',
                    host: p.host || '',
                    port: p.port || '',
                    protocol: p.protocol || '',
                    synctype: p.synctype || '',
                    status: p.status || '',
                    id: p.id || ''
                  };
                });
                _this6.refresh();
              }, this.mod.server_publickey);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadLivePeers() {
        return _loadLivePeers.apply(this, arguments);
      }
      return loadLivePeers;
    }()
  }]);
}();
module.exports = AdminPeersUI;